import {GatsbyImage, IGatsbyImageData} from "gatsby-plugin-image";
import cls from "classnames";
import * as styles from "src/components/organisms/ContentLibrary/styles.module.scss";
import {capitalize, getColorFromString} from "util/functions";
import {IdHeading} from "src/components/organisms/IdHeading";
import * as React from "react";
import {SmartLink} from "components/atoms/SmartLink";

export const AbstractContentLibraryCard = (props: {
    title: string,
    description: string,
    timeToRead?: string | null,
    publishedAt: string,
    author?: string | null,
    coverImageData?: IGatsbyImageData,
    category: string | null,
    headingClassname?: string | null,
    headingLevel: 1 | 2 | 3 | 4 | 5 | 6,
    link: string,
    className?: string,
    id?: string
}) => {

    const {
        title,
        description,
        timeToRead,
        publishedAt,
        author,
        category,
        coverImageData,
        link,
        className
    } = props

    const typeToText = (type: string | null | undefined) => {
        const typeMap: Record<string, string> = {
            "ebook" : "E-Book"
        }

        return typeMap[String(type)] || capitalize(String(type?.replaceAll("-", " ")))
    }

    const typeToBtn = (type: string | null | undefined) => {
        const typeMap: Record<string, string> = {
            "videos" : "Watch Now",
            "webinar": "See More",
            "ebook": "Read Now",
            "product-paper": "Read Now",
            "onepager": "Read Now"
        }

        return typeMap[String(type)] || "Read"
    }

    return (
        <div className={cls(styles.blog_wrapper, className)} id={props.id}>
            <div className={cls(styles.card_type, getColorFromString(String(category)))}>
                {typeToText(category)}
            </div>
            <div className={styles.card_container}>
                <div className={cls(styles.card_header, "bg-dark")}>

                    {coverImageData &&
                        <GatsbyImage alt="card image"
                                     objectPosition={"top left"}
                                     image={coverImageData}></GatsbyImage>
                    }

                </div>
                <div className={styles.card_main}>
                    <div className={styles.card_caption}>
                        <IdHeading headingLevel={6} className={styles.card_date}>
                            {new Date(publishedAt).toLocaleDateString('en-us', {
                                year: "numeric",
                                month: "short",
                                day: "numeric"
                            })}
                        </IdHeading>
                    </div>
                    <IdHeading headingLevel={5} className={cls("color-black")}>{title}</IdHeading>
                    {description && <p className={styles.card_text}>{description}</p>}
                    <div className={styles.button_container}>
                        <SmartLink style={{
                            height: "44px"
                        }}
                              to={link}
                              className={cls("button-filled", "button-bordered", "bg-white", "hover-bg-blue")}>{typeToBtn(category)}</SmartLink>
                    </div>
                </div>
            </div>
        </div>
    )
}


export const SkeletonContentLibraryCard = () => {
    return (
        <div className={cls(styles.blog_wrapper)}>
            <div className={cls(styles.card_type, getColorFromString(`${Math.random()}`))}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div className={cls(styles.loadingItem, styles.tint, styles.borderRadius)}></div>
            </div>
            <div>
                <div className={cls(styles.card_header, "bg-dark")}>
                    <div style={{
                        height: "240px"
                    }}>

                    </div>
                </div>
                <div className={cls(styles.card_main, styles.loadingItem)}>
                    <div className={styles.card_caption}>
                        &nbsp;
                    </div>
                    <IdHeading headingLevel={5} className={cls("color-black")}>&nbsp;</IdHeading>
                    &nbsp;
                    <div className={styles.button_container}>
                        &nbsp;
                    </div>
                </div>
            </div>
        </div>
    )
}